'use client'
// React
import React, { useState } from 'react'
// Components
import { Skeleton } from '@/CommonComponents'
import MarkdownViewer from './MarkdownViewer'
import MarkdownEditor from './MarkdownEditor'

interface IMarkdownProps {
  content: string
  loading?: boolean
  placeholder?: string
  onChange?: (newContent: string) => void
}

export default function Markdown({ content, loading, onChange, placeholder }: IMarkdownProps) {
  const [isEditing, setIsEditing] = useState(false)

  const handleEditClick = () => {
    if (onChange) {
      setIsEditing(true)
    }
  }

  const handleSave = (newContent: string) => {
    if (onChange) {
      onChange(newContent)
      setIsEditing(false)
    }
  }

  if (loading) return <Skeleton variant="rectangular" height={100} />

  if (isEditing) {
    return <MarkdownEditor content={content} onChange={handleSave} />
  }

  return (
    <MarkdownViewer
      content={content}
      onChange={onChange}
      onEditClick={onChange ? handleEditClick : () => {}}
      placeholder={placeholder}
    />
  )
}
